import { render } from "./TrainingElements.vue?vue&type=template&id=57b05d26"
import script from "./TrainingElements.vue?vue&type=script&lang=js"
export * from "./TrainingElements.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__